module.exports = __webpack_public_path__ + "media/images/front/consentio-4836cf60578e96cc31c89b07629d0343.png";